import { render, staticRenderFns } from "./VideoListView.vue?vue&type=template&id=1ab75d46&scoped=true"
import script from "./VideoListView.vue?vue&type=script&lang=js"
export * from "./VideoListView.vue?vue&type=script&lang=js"
import style0 from "./VideoListView.vue?vue&type=style&index=0&id=1ab75d46&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab75d46",
  null
  
)

export default component.exports